/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import logger from "@insite/client-framework/Logger";
import FieldDefinition from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Carousel from "@insite/content-library/Components/Carousel";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import { ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import DynamicDropdown from "@insite/mobius/DynamicDropdown";
import Icon from "@insite/mobius/Icon";
import Moon from "@insite/mobius/Icons/Moon";
import {
    Accordion,
    AccordionSection,
    Breadcrumbs,
    Button,
    Checkbox,
    CheckboxGroup,
    DataTable,
    DataTableBody,
    DataTableCell,
    DataTableHead,
    DataTableHeader,
    DataTableRow,
    DatePicker,
    GridContainer,
    GridItem,
    LoadingSpinner,
    Pagination,
    Radio,
    RadioGroup,
    Select,
    TabGroup,
    TextArea,
    TextField,
    Tooltip,
} from "@insite/mobius/index";
import Link from "@insite/mobius/Link";
import ListItem, { OrderedList, UnorderedList } from "@insite/mobius/Lists";
import Modal from "@insite/mobius/Modal";
import Tab from "@insite/mobius/Tab";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography from "@insite/mobius/Typography";
import Notify from "@monsma/XDL/Components/Notify";

import translate from "@insite/client-framework/Translate";
import {
    dataTable,
    dummyLinks,
    dummyProductContext,
    dynamicDropdownOptions,
    longText,
} from "@monsma/App/Widgets/DesignSystem/DummyData";
import React, { useState } from "react";
import { css } from "styled-components";

const XdlTable = () => {
    const ReorderButton = () => (
        <Button variant="secondary" sizeVariant="small">
            Reorder
        </Button>
    );
    const FakeLink = (props: any) => <Link href="#" typographyProps={{ size: 13 }} {...props} />;

    return (
        <DataTable>
            <DataTableHead>
                <DataTableHeader onSortClick={() => logger.log("sorting")} tight>
                    Date
                </DataTableHeader>
                <DataTableHeader onSortClick={() => logger.log("sorting")} tight title="Order Number">
                    Order #
                </DataTableHeader>
                <DataTableHeader>Ship To</DataTableHeader>
                <DataTableHeader onSortClick={() => logger.log("sorting")} sorted="descending" tight>
                    Status
                </DataTableHeader>
                <DataTableHeader onSortClick={() => logger.log("sorting")} tight title="Purchase Order Number">
                    PO #
                </DataTableHeader>
                <DataTableHeader tight>Order Total</DataTableHeader>
                <DataTableHeader tight title="reorder"></DataTableHeader>
            </DataTableHead>
            <DataTableBody>
                {dataTable.map(({ date, order, shipTo, status, po, total }) => (
                    <DataTableRow key={order}>
                        <DataTableCell>
                            <FakeLink>{date}</FakeLink>
                        </DataTableCell>
                        <DataTableCell>
                            <FakeLink>{order}</FakeLink>
                        </DataTableCell>
                        <DataTableCell>{shipTo}</DataTableCell>
                        <DataTableCell>{status}</DataTableCell>
                        <DataTableCell>{po}</DataTableCell>
                        <DataTableCell>${total}</DataTableCell>
                        <DataTableCell alignX="right">
                            <ReorderButton />
                        </DataTableCell>
                    </DataTableRow>
                ))}
            </DataTableBody>
        </DataTable>
    );
};

const XdlTooltip = () => {
    const Spacer = () => <div style={{ display: "inline-block", width: "40px" }} />;
    const triggerLink = <Link>this?</Link>;

    return (
        <>
            <Typography>What's this? </Typography>
            <Tooltip text={longText} />
            <Spacer />
            <Typography>And this? </Typography>
            <Tooltip iconProps={{ src: Moon }} text="Night mode" />
            <Spacer />
            <Typography>How about </Typography>
            <Tooltip triggerComponent={triggerLink} text="custom trigger" />
        </>
    );
};

const XdlAccordion = () => {
    return (
        <Accordion headingLevel={4}>
            <ManagedAccordionSection title="Accessibility" initialExpanded={true} onTogglePanel={() => {}}>
                <Typography as="div">{longText}</Typography>
                <Typography as="div">{longText}</Typography>
            </ManagedAccordionSection>
            <AccordionSection title="Details">
                <Typography as="div">{longText}</Typography>
                <Typography as="div">{longText}</Typography>
                <Button>Another Focusable Element</Button>
            </AccordionSection>
            <AccordionSection title="Specifications">
                <Typography as="div">{longText}</Typography>
                <Typography as="div">{longText}</Typography>
                <Button>Another Focusable Element</Button>
            </AccordionSection>
            <AccordionSection title="Documents">
                <Typography as="div">{longText}</Typography>
                <Typography as="div">{longText}</Typography>
                <Typography>{longText}</Typography>
            </AccordionSection>
        </Accordion>
    );
};

const XdlList = () => {
    return (
        <>
            <GridItem width={6}>
                <UnorderedList>
                    <ListItem>
                        {" "}
                        Item 1
                        <UnorderedList>
                            <ListItem>Item 1.1</ListItem>
                            <ListItem>Item 1.2</ListItem>
                            <ListItem>Item 1.3</ListItem>
                        </UnorderedList>
                    </ListItem>
                    <ListItem>Item 2</ListItem>
                    <ListItem>Item 3</ListItem>
                    <ListItem>Item 4</ListItem>
                </UnorderedList>
            </GridItem>
            <GridItem width={6}>
                <OrderedList>
                    <ListItem>
                        {" "}
                        Item 1
                        <OrderedList>
                            <ListItem>Item 1.1</ListItem>
                            <ListItem>Item 1.2</ListItem>
                            <ListItem>Item 1.3</ListItem>
                        </OrderedList>
                    </ListItem>
                    <ListItem>Item 2</ListItem>
                    <ListItem>Item 3</ListItem>
                    <ListItem>Item 4</ListItem>
                </OrderedList>
            </GridItem>
        </>
    );
};

const XdlDatePicker = () => {
    return (
        <GridContainer>
            <GridItem width={4}>
                <DatePicker label="Date" />
            </GridItem>
            <GridItem width={4}>
                <DatePicker label="Date (required)" required />
            </GridItem>
            <GridItem width={4}>
                <DatePicker label="Date (selected)" selectedDay={new Date(2019, 8, 12)} />
            </GridItem>
        </GridContainer>
    );
};

const XdlSelect = () => {
    const children = [
        <option key={1} value={1}>
            apple
        </option>,
        <option key={2} value={2}>
            bananas
        </option>,
        <option key={3} value={3}>
            cherries
        </option>,
    ];
    const [value, setValue] = useState("");
    const logTargetValue = (e: any) => {
        setValue(e.target.value);
    };

    return (
        <Select label="Select the best one" required placeholder="Select" value={value} onChange={logTargetValue}>
            {children}
        </Select>
    );
};

const XdlCheckBox = () => {
    return (
        <CheckboxGroup label="Checkbox Group Label">
            <Checkbox checked>Checked</Checkbox>
            <Checkbox>Unchecked</Checkbox>
            <Checkbox checked disabled>
                Disabled Checked
            </Checkbox>
            <Checkbox disabled>Disabled</Checkbox>
        </CheckboxGroup>
    );
};

const XdlDynamicDropdown = () => {
    const [value, setValue] = useState("");
    const handleSelectionChange = (value: any) => setValue(value);

    return (
        <DynamicDropdown
            options={dynamicDropdownOptions}
            label="Dynamic Dropdown"
            selected={value}
            onSelectionChange={handleSelectionChange}
        />
    );
};

const XdlTextField = () => {
    const [value, setValue] = useState("");
    const logTargetValue = (e: any) => {
        setValue(e.target.value);
    };

    return (
        <GridItem width={12}>
            <GridItem width={4}>
                <TextField
                    value={value}
                    onChange={logTargetValue}
                    label="User Name"
                    data-test-selector="userName"
                    disabled={false}
                    required={true}
                />
            </GridItem>
            <GridItem width={4}>
                <TextField
                    disabled={true}
                    label="User Name"
                    value=""
                    data-test-selector="userName"
                    onChange={() => {}}
                />
            </GridItem>
            <GridItem width={4}>
                <TextField label="User Name" value="" error="Error" data-test-selector="userName" onChange={() => {}} />
            </GridItem>
        </GridItem>
    );
};

const XdlBreadcrumbs = () => {
    return (
        <GridContainer>
            <GridItem width={12}>
                <Breadcrumbs links={dummyLinks.slice(0, 4)} />
            </GridItem>
            <GridItem width={12}>
                <Breadcrumbs links={dummyLinks} />
            </GridItem>
        </GridContainer>
    );
};

const XdlRadio = () => {
    const [value, setValue] = useState("All");
    const logTargetValue = (e: any) => {
        setValue(e.target.value);
    };
    return (
        <RadioGroup value={value} onChangeHandler={logTargetValue}>
            <Radio key="All">All</Radio>
            <Radio key="Unread">Unread</Radio>
            <Radio key="Read">Read</Radio>
        </RadioGroup>
    );
};

const XdlToast = () => {
    const toasterContext = React.useContext(ToasterContext);

    return (
        <>
            <Button shape="rounded" onClick={() => toasterContext.addToast({ body: "Test", messageType: "success" })}>
                Toast
            </Button>
        </>
    );
};

const XdlTextArea = () => {
    const [value, setValue] = useState("");
    const logTargetValue = (e: any) => {
        setValue(e.target.value);
    };

    return (
        <GridItem width={12}>
            <GridItem width={4}>
                <TextArea
                    onChange={logTargetValue}
                    value={value}
                    placeholder="Type some long content"
                    label="Description"
                />
            </GridItem>
            <GridItem width={4}>
                <TextArea label="TextArea" value={longText} onChange={() => {}} />
            </GridItem>
            <GridItem width={4}>
                <TextArea disabled label="TextArea" value={longText} onChange={() => {}} />
            </GridItem>
        </GridItem>
    );
};

const XdlAddToCart = () => {
    return (
        <>
            <GridItem width={3}>
                <ProductContext.Provider value={dummyProductContext}>
                    <ProductAddToCartButton data-test-selector="actionsAddToCart-545454654" />
                </ProductContext.Provider>
            </GridItem>
            <GridItem width={3}>
                <ProductContext.Provider value={dummyProductContext}>
                    <ProductAddToCartButton data-test-selector="actionsAddToCart-545454654" />
                </ProductContext.Provider>
            </GridItem>
            <GridItem width={3}>
                <ProductContext.Provider value={dummyProductContext}>
                    <ProductAddToCartButton data-test-selector="actionsAddToCart-545454654" />
                </ProductContext.Provider>
            </GridItem>
        </>
    );
};

const XdlButton = () => {
    return (
        <>
            <GridItem width={12}>
                <Typography variant="h3">Buttons</Typography>
            </GridItem>
            <GridItem width={3}>
                <Button sizeVariant="large">Primary</Button>
            </GridItem>
            <GridItem width={3}>
                <Button sizeVariant="medium">Primary</Button>
            </GridItem>
            <GridItem width={3}>
                <Button disabled sizeVariant="medium">
                    Disabled
                </Button>
            </GridItem>
            <GridItem width={3}>
                <Button sizeVariant="small" variant="primary">
                    small
                </Button>
            </GridItem>
            <GridItem width={3}>
                <Button variant="secondary" sizeVariant="large">
                    secondary
                </Button>
            </GridItem>
            <GridItem width={3}>
                <Button variant="secondary" sizeVariant="medium">
                    secondary
                </Button>
            </GridItem>
            <GridItem width={3}>
                <Button variant="secondary" disabled sizeVariant="medium">
                    Disabled
                </Button>
            </GridItem>
            <GridItem width={3}>
                <Button variant="secondary" sizeVariant="small">
                    small
                </Button>
            </GridItem>
            <GridItem width={3}>
                <Button variant="tertiary" sizeVariant="large">
                    tertiary
                </Button>
            </GridItem>
            <GridItem width={3}>
                <Button variant="tertiary" sizeVariant="medium">
                    tertiary
                </Button>
            </GridItem>
            <GridItem width={3}>
                <Button variant="tertiary" disabled sizeVariant="medium">
                    Disabled
                </Button>
            </GridItem>
            <GridItem width={3}>
                <Button variant="tertiary" sizeVariant="small">
                    small
                </Button>
            </GridItem>

            <GridItem width={12}>
                <XdlAddToCart />
            </GridItem>
        </>
    );
};

const XdlLinks = () => {
    return (
        <>
            <GridItem width={6}>
                <Link href="#">View All</Link>
            </GridItem>
        </>
    );
};

const XdlModal = () => {
    const [state, setState] = useState({ open: false });
    const openModal = () => {
        setState({ open: true });
    };

    const closeModal = () => {
        setState({ open: false });
    };

    return (
        <GridItem width={12}>
            <Button onClick={openModal}>Open Modal</Button>
            <Modal
                isOpen={state.open}
                handleClose={closeModal}
                headline="Transactional modal title"
                contentLabel="the basic modal"
                sizeVariant="medium"
            >
                <Typography variant="p">
                    Transactional modals are used to validate decisions or to gain secondary confirmation from the user.
                    Typically, the modal requests either a 'yes' or 'no' response.
                </Typography>
                <StyledWrapper className="modal-actions">
                    <Button color="secondary" onClick={closeModal}>
                        Cancel
                    </Button>
                    <Button onClick={closeModal}>Save</Button>
                </StyledWrapper>
            </Modal>
        </GridItem>
    );
};

const XdlPagination = () => {
    const [value, setValue] = useState("");
    const changeNumberOfResultsPerPage = () => setValue(value);
    const changePage = () => logger.log("Hey");

    return (
        <Pagination
            resultsPerPage={8}
            resultsCount={64}
            currentPage={1}
            resultsPerPageLabel="Results Per Page"
            resultsPerPageOptions={[5, 10, 50, 100]}
            onChangeResultsPerPage={changeNumberOfResultsPerPage}
            onChangePage={changePage}
        />
    );
};

const IconDemo = ({ iconSrc, name }: { iconSrc: any; name: any }) => (
    <div
        style={{
            textAlign: "center",
            borderRadius: 8,
            border: "1px solid #ccc",
            padding: 15,
            overflowWrap: "break-word",
        }}
    >
        <Icon
            src={iconSrc}
            size={32}
            css={css`
                margin-bottom: 15px;
            `}
        />
        <Typography
            css={css`
                display: block;
            `}
            size={12}
            color="text.accent"
        >
            {name}
        </Typography>
    </div>
);

const XdlIcons = () => {
    return (
        <>
            <div
                style={{
                    display: "grid",
                    marginBottom: 30,
                    gridTemplateColumns: "repeat(9, minmax(0, 1fr))",
                    gridColumnGap: "20px",
                    gridRowGap: "20px",
                }}
            >
                Implement Icons!
            </div>
        </>
    );
};

export const XdlTab = () => {
    return (
        <TabGroup>
            <Tab headline="Buttons" tabKey="Buttons">
                <section style={{ display: "flex", width: "100%" }}>
                    <GridContainer>
                        <XdlButton />
                    </GridContainer>
                </section>
            </Tab>
            <Tab headline="Pagination" tabKey="Pagination">
                <section style={{ display: "flex", width: "100%" }}>
                    <GridContainer>
                        <XdlPagination />
                    </GridContainer>
                </section>
            </Tab>
            <Tab headline="Table" tabKey="Table">
                <section style={{ display: "flex", width: "100%" }}>
                    <GridContainer>
                        <GridItem width={12}>
                            <Typography variant="h3">Tables</Typography>
                        </GridItem>
                        <GridItem width={12}>
                            <XdlTable />
                        </GridItem>
                    </GridContainer>
                </section>
            </Tab>
            <Tab headline="Tooltip" tabKey="Tooltip">
                <section style={{ display: "flex", width: "100%" }}>
                    <GridContainer>
                        <GridItem width={12}>
                            <Typography variant="h3">Tooltip</Typography>
                        </GridItem>
                        <GridItem width={12}>
                            <XdlTooltip />
                        </GridItem>
                    </GridContainer>
                </section>
            </Tab>
            <Tab headline="Accordions" tabKey="Accordions">
                <section style={{ display: "flex", width: "100%" }}>
                    <GridContainer>
                        <GridItem width={12}>
                            <Typography variant="h3">Accordions</Typography>
                        </GridItem>
                        <GridItem width={12}>
                            <XdlAccordion />
                        </GridItem>
                    </GridContainer>
                </section>
            </Tab>
            <Tab headline="Toast" tabKey="Toast">
                <section style={{ display: "flex", width: "100%" }}>
                    <GridContainer>
                        <GridItem width={12}>
                            <Typography variant="h3">Toast</Typography>
                        </GridItem>
                        <GridItem width={12}>
                            <XdlToast />
                        </GridItem>
                    </GridContainer>
                </section>
            </Tab>
            <Tab headline="Notify" tabKey="Notify">
                <section style={{ display: "flex", width: "100%" }}>
                    <GridContainer>
                        <GridItem width={12}>
                            <Typography variant="h3">Notify</Typography>
                        </GridItem>
                        <GridItem width={12}>
                            <Notify messageType="danger" body={translate("No orders found")} />
                        </GridItem>
                        <GridItem width={12}>
                            <Notify messageType="info" body={translate("Information")} />
                        </GridItem>
                        <GridItem width={12}>
                            <Notify messageType="warning" body={translate("Warning")} />
                        </GridItem>
                        <GridItem width={12}>
                            <Notify messageType="success" body={translate("Success")} />
                        </GridItem>
                    </GridContainer>
                </section>
            </Tab>
            <Tab headline="Breadcrumbs" tabKey="Breadcrumbs">
                <section style={{ display: "flex", width: "100%" }}>
                    <GridContainer>
                        <GridItem width={12}>
                            <Typography variant="h3">Breadcrumbs</Typography>
                        </GridItem>
                        <GridItem width={12}>
                            <XdlBreadcrumbs />
                        </GridItem>
                    </GridContainer>
                </section>
            </Tab>
            <Tab headline="Form" tabKey="Form">
                <section style={{ display: "flex", width: "100%" }}>
                    <GridContainer>
                        <GridItem width={12}>
                            <Typography variant="h3">List</Typography>
                        </GridItem>
                        <XdlList />
                        <GridItem width={12}>
                            <Typography variant="h3">DatePicker</Typography>
                        </GridItem>
                        <GridItem width={12}>
                            <LoadingSpinner color="primary" />
                        </GridItem>
                        <XdlDatePicker />
                        <GridItem width={12}>
                            <Typography variant="h3">CheckBox & Radio</Typography>
                        </GridItem>
                        <GridItem width={12}>
                            <GridItem width={6}>
                                <XdlCheckBox />
                            </GridItem>
                            <GridItem width={6}>
                                <XdlRadio />
                            </GridItem>
                        </GridItem>

                        <GridItem width={12}>
                            <Typography variant="h3">TextFiled</Typography>
                        </GridItem>
                        <XdlTextField />
                        <GridItem width={12}>
                            <Typography variant="h3">TextArea</Typography>
                        </GridItem>
                        <XdlTextArea />
                        <GridItem width={12}>
                            <Typography variant="h3">Select</Typography>
                        </GridItem>
                        <GridItem width={12}>
                            <XdlSelect />
                        </GridItem>

                        <GridItem width={12}>
                            <Typography variant="h3">Dynamic DropDown</Typography>
                        </GridItem>
                        <GridItem width={12}>
                            <XdlDynamicDropdown />
                        </GridItem>
                    </GridContainer>
                </section>
            </Tab>
            <Tab headline="Links" tabKey="Links">
                <section style={{ display: "flex", width: "100%" }}>
                    <GridContainer>
                        <GridItem width={12}>
                            <Typography variant="h3">Links</Typography>
                        </GridItem>
                        <XdlLinks />
                    </GridContainer>
                </section>
            </Tab>
            <Tab headline="Modal" tabKey="Modal">
                <section style={{ display: "flex", width: "100%" }}>
                    <GridContainer>
                        <GridItem width={12}>
                            <Typography variant="h3">Modal</Typography>
                        </GridItem>
                        <XdlModal />
                    </GridContainer>
                </section>
            </Tab>
            <Tab headline="Icons" tabKey="Icons">
                <section style={{ display: "flex", width: "100%" }}>
                    <GridContainer>
                        <GridItem width={12}>
                            <Typography variant="h3">Icons</Typography>
                        </GridItem>
                        <GridItem width={12}>
                            <XdlIcons />
                        </GridItem>
                    </GridContainer>
                </section>
            </Tab>
            <Tab headline="Carousel" tabKey="Carousel">
                <section style={{ display: "flex", width: "100%" }}>
                    <GridContainer>
                        <GridItem width={12}>
                            <Typography variant="h3">Carousel Component</Typography>
                        </GridItem>
                        <GridItem width={12}>
                            <Carousel
                                title=""
                                id="someId"
                                maxNumberOfColumns={4}
                                {...({ showArrows: true, showDots: true, slidesGap: 15 } as any)}
                                slides={[
                                    {
                                        id: "slide1",
                                        renderComponent: () => (
                                            <StyledWrapper
                                                css={css`
                                                    background: red;
                                                `}
                                            >
                                                Slide 1
                                            </StyledWrapper>
                                        ),
                                    },
                                    {
                                        id: "slide2",
                                        renderComponent: () => (
                                            <StyledWrapper
                                                css={css`
                                                    background: green;
                                                `}
                                            >
                                                Slide 2
                                            </StyledWrapper>
                                        ),
                                    },
                                    {
                                        id: "slide3",
                                        renderComponent: () => (
                                            <StyledWrapper
                                                css={css`
                                                    background: yellow;
                                                `}
                                            >
                                                Slide 3
                                            </StyledWrapper>
                                        ),
                                    },
                                    {
                                        id: "slide4",
                                        renderComponent: () => (
                                            <StyledWrapper
                                                css={css`
                                                    background: blue;
                                                `}
                                            >
                                                Slide 4
                                            </StyledWrapper>
                                        ),
                                    },
                                    {
                                        id: "slide5",
                                        renderComponent: () => (
                                            <StyledWrapper
                                                css={css`
                                                    background: pink;
                                                `}
                                            >
                                                Slide 5
                                            </StyledWrapper>
                                        ),
                                    },
                                ]}
                            />
                        </GridItem>
                    </GridContainer>
                </section>
            </Tab>
        </TabGroup>
    );
};

const DesignSystemWidget = () => {
    return <XdlTab />;
};

const widgetModule: WidgetModule<FieldDefinition> = {
    component: DesignSystemWidget,
    definition: {
        group: "Design System" as any,
        icon: "DesignSystem",
    },
};

export default widgetModule;
